<div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <!--  TO-DOS   -->
        <div>
            <h4 class="mb-2 font-semibold">To-Do</h4>
            <div
                [routerLink]="'/todo'"
                class="bg-[#dddddd] hover:bg-[#cccccc] rounded-lg p-3 cursor-pointer min-h-[85px]"
                rcpComLoadingOverlay
                [isLoading]="isLoading">
                <div
                    *ngIf="
                        worklistSummary?.taskWorklistSummary?.activeCount > 0
                    ">
                    <div class="leading-5 mb-1">
                        <span class="font-semibold text-[22px]">
                            {{
                                worklistSummary?.taskWorklistSummary
                                    ?.activeCount
                            }}
                        </span>
                        <span>Active</span>
                    </div>
                    <div class="flex flex-col text-[12px]">
                        <span
                            *ngIf="
                                worklistSummary?.taskWorklistSummary
                                    ?.overdueCount > 0
                            ">
                            {{
                                worklistSummary?.taskWorklistSummary
                                    ?.overdueCount
                            }}
                            Overdue
                        </span>
                        <span
                            *ngIf="
                                worklistSummary?.taskWorklistSummary
                                    ?.dueTodayCount > 0
                            ">
                            {{
                                worklistSummary?.taskWorklistSummary
                                    ?.dueTodayCount
                            }}
                            Due Today
                        </span>
                    </div>
                </div>
                <div
                    *ngIf="
                        worklistSummary?.taskWorklistSummary?.activeCount === 0
                    "
                    class="flex flex-col gap-2">
                    <span>
                        <i
                            class="fa-solid fa-thumbs-up text-success-green fa-lg mr-1"></i>
                        Nice Job!
                    </span>
                    <span class="text-sm">No To-Dos to review today.</span>
                </div>
            </div>
        </div>

        <!--   NOTIFICATIONS   -->
        <div>
            <h4 class="mb-2 font-semibold">Notifications</h4>
            <div
                [routerLink]="'/notifications'"
                class="bg-[#dddddd] hover:bg-[#cccccc] rounded-lg p-3 cursor-pointer min-h-[85px]"
                rcpComLoadingOverlay
                [isLoading]="isLoading">
                <div
                    *ngIf="
                        worklistSummary?.notificationWorklistSummary
                            ?.activeCount > 0
                    ">
                    <div class="leading-5 mb-1">
                        <span class="font-semibold text-[22px]">
                            {{
                                worklistSummary?.notificationWorklistSummary
                                    ?.activeCount
                            }}
                        </span>
                        <span>Open</span>
                    </div>
                    <div class="flex flex-col text-[12px]">
                        <span
                            *ngIf="
                                worklistSummary?.notificationWorklistSummary
                                    ?.highPriorityCount > 0
                            ">
                            {{
                                worklistSummary?.notificationWorklistSummary
                                    ?.highPriorityCount
                            }}
                            High Priority
                        </span>
                        <span
                            *ngIf="
                                worklistSummary?.notificationWorklistSummary
                                    ?.normalPriorityCount > 0
                            ">
                            {{
                                worklistSummary?.notificationWorklistSummary
                                    ?.normalPriorityCount
                            }}
                            Normal Priority
                        </span>
                    </div>
                </div>
                <div
                    *ngIf="
                        worklistSummary?.notificationWorklistSummary
                            ?.activeCount === 0
                    "
                    class="flex flex-col gap-1">
                    <span>
                        <i
                            class="fa-solid fa-thumbs-up text-success-green fa-lg mr-1"></i
                        >All Clear!
                    </span>
                    <span class="text-[12px]"
                        >You have no open notifications.</span
                    >
                </div>
            </div>
        </div>

        <!--   ISSUES   -->
        <!--<div
            routerLink="../worklist/issues"
            class="flex flex-col justify-center items-center min-w-[220px] h-full rounded cursor-pointer p-2 border border-transparent hover:border-gray-border hover:bg-gray-hover">
            <div class="flex flex-col w-full">
                <div class="flex flex-row justify-center items-center">
                    <div
                        class="min-w-[65px] min-h-[65px] flex justify-center items-center border-solid border-2 border-main-red rounded-full m-2 bg-gradient-to-b from-neutral-50 to-stone-300">
                        <i class="fa-solid fa-diamond fa-2xl"></i>
                    </div>
                </div>
                <div
                    class="flex flex-row font-semibold w-full justify-center border-b-2 pb-1 text-lg">
                    Issues
                </div>
                <div class="flex flex-col p-2 min-h-[78px]">
                    <span>Coming Soon</span>
                    <span class="text-sm"
                        >&#8226; View & Track Aging Issues</span
                    >
                </div>
            </div>
        </div>-->
    </div>
</div>
